import { render, staticRenderFns } from "./NaviArchive.vue?vue&type=template&id=5008ff6a&scoped=true&"
import script from "./NaviArchive.vue?vue&type=script&lang=ts&"
export * from "./NaviArchive.vue?vue&type=script&lang=ts&"
import style0 from "./NaviArchive.vue?vue&type=style&index=0&id=5008ff6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008ff6a",
  null
  
)

export default component.exports